export default "__VITE_ASSET__c3ec94b0__"